export const notasList = [
   {
    id: 9,
    titulo: "Imagine the Future",
    contenido: [
      { tipo: "subtitulo", text: "The future isn’t something we discover." },
  
      { tipo: "giro", text: "It is something we design." },
  
      {
        tipo: "parrafo",
        text: "It means creating enough clarity to move intentionally toward what matters most.",
      },
  
      { tipo: "parrafo", text: "Not every circumstance is ours to choose." },
      { tipo: "parrafo", text: "Our response almost always is." },
      { tipo: "parrafo", text: "Imagining the future isn’t about hoping for change." },

      {
        
      tipo: "giro", text: "It is intentional thinking."
      },

      {      
        tipo: "parrafo",text: "It asks us to pause. ",
      },
      { tipo: "parrafo",text: "To reflect. ",
      },
      { tipo: "parrafo",text: "To question. ",
      },
      { tipo: "parrafo",text: "To see possibilities before they become plans. ",
      },
      { tipo: "parrafoBloque",text: "but because it is undefined. ",
      },
      
      { tipo: "giro", text: "Imagine the Future is more than the name."
      },
      
      { tipo: "cierreRegular", text: "It is the philosophy that guides every conversation," },
     
      
      {
        tipo: "cierreRegular", text: "every engagement," },
      { 
        tipo: "cierreRegular", text: "and every partnership." 
      },
      ],
  },

  {
    id:10,
    titulo: "The Journey",
    contenido: [
    { tipo: "subtitulo", text: "Every journey is different." },  
    { tipo: "giro", text: "Just like every career." },  

    {
        tipo: "parrafo",
        text: "There are twists and turns.",
      },
      { tipo: "parrafo", text: "Uphill climbs." },
      { tipo: "parrafo", text: "Unexpected detours." },
      { tipo: "parrafo", text: "And moments that ask us to pause.",
      },
      { tipo: "parrafo", text: "Sometimes we choose our path." },
      { tipo: "parrafo", text: "Sometimes life leads us to it." ,
    },   
      { tipo: "giro", text: "The challenge is not to follow a perfect plan." },
      
      { tipo: "parrafo", text: "It is to keep moving with purpose, clarity and intention." },
      { tipo: "parrafo", text: "To recognize when the path no longer fits." },
      { tipo: "parrafoBloque", text: "And to have the courage to change direction when you must." },
  
      { tipo: "giro", text: "Every journey teaches us something." },
      
      { tipo: "parrafo", text: "Not only about where we are going." },
      { tipo: "parrafoBloque", text: "But about who we are becoming." },
      
        { tipo: "cierreBold", text: "Destination matters." },
      { tipo: "cierreRegular", text: "The journey shapes who we become." },
    ],
  },
      
    
  {
    id: 11,
    titulo: "What Leadership Is Not",
    contenido: [
      { tipo: "subtitulo", "text": "Leadership is not control." },
      { tipo: "subtitulo", "text": "It is not having all the answers." },
      { tipo: "subtitulo", "text": "It is not making every decision." },
  
      {
        tipo: "giro",
        "text": "And it is not about the leader."
      },
      { tipo: "giro", "text": "Leadership begins with mission and vision."
      },
      { tipo: "parrafo", "text": "With a strategy, and the ability to communicate both clearly." 
      },
     
      { 
      tipo: "giro", "text": "Leaders create understanding around what matters,"
       },
       { 
      tipo: "giro", "text": "why it matters, and where we are going."
      
      },
      {      
        tipo: "parrafo","text": "They listen."
      },
      { tipo: "parrafo","text": "They challenge."
      },
      { tipo: "parrafo","text": "They build trust."
      },
      { tipo: "parrafo","text": "They hold people accountable."
      },
      { tipo: "parrafoBloque",text: "They create the conditions for people to grow and do their best work. ",
      },
      { tipo: "parrafo","text": "Control may produce compliance."
      },
       { tipo: "giro", "text": "But it rarely brings out the best in people."
       },
      { tipo: "giro", "text": "Leadership is not about being at the center."
      },
      
      { tipo: "cierreRegular", text: "It is moving aside to let others create, fail, learn, and move forward together."},
     
      ],
      },
   
    {
    id: 1,
    titulo: "Clarity Changes Everything",
    contenido: [
      { tipo: "subtitulo", text: "Most people don’t lack options." },
      { tipo: "giro", text: "They lack clarity." },

      {
        tipo: "parrafo",
        text: "When direction is unclear, everything feels harder.",
      },
      { tipo: "parrafo", text: "Decisions take longer." },
      { tipo: "parrafo", text: "Effort increases." },
      { tipo: "parrafo", text: "Confidence drops." },

      {
        tipo: "parrafo",
        text: "Not because the path is complex — ",
      },
      {
        tipo: "parrafoBloque",
        text: "but because it’s undefined.",
      },

      { tipo: "giro", text: "Clarity simplifies." },

      { tipo: "parrafo", text: "It allows you to focus your energy," },

      { tipo: "parrafo", text: "communicate your value," },
      { tipo: "parrafoBloque", text: "and move forward with intention." },

      { tipo: "cierreBold", text: "Clarity is not a luxury." },
      { tipo: "cierreRegular", text: "It is the foundation." },
    ],
  },
  {
    id: 2,
    titulo: "Positioning Shapes Perception",
    contenido: [
      {
        tipo: "subtitulo",
        text: "Most people don’t struggle because they lack \nexperience.",
      },
      {
        tipo: "giro",
        text: "They struggle because they don’t position it \nclearly.",
      },

      {
        tipo: "parrafo",
        text: "Experience alone doesn’t communicate value.",
      },
      {
        tipo: "parrafoBloque",
        text: "It needs structure, context, and direction.",
      },

      { tipo: "parrafo", text: "Without positioning, work feels fragmented." },
      { tipo: "parrafo", text: "Strengths are diluted." },
      { tipo: "parrafoBloque", text: "The message is unclear." },

      {
        tipo: "parrafo",
        text: "People don’t see everything you’ve done.",
      },
      {
        tipo: "parrafo",
        text: "They can only understand what you make clear.",
      },

      { tipo: "giro", text: "Positioning brings coherence." },

      {
        tipo: "parrafo",
        text: "It connects your experience into a clear narrative",
      },
      {
        tipo: "parrafoBloque",
        text: "others can understand, and trust.",
      },

      { tipo: "cierreBold", text: "Positioning is not about reinvention." },
      { tipo: "cierreRegular", text: "It’s about alignment." },
    ],
  },
  {
    id: 3,
    titulo: "Decisions Create Direction",
    contenido: [
      {
        tipo: "subtitulo",
        text: "Most people don’t lack experience.",
      },
      {
        tipo: "giro",
        text: "They lack the ability to make decisions.",
      },

      {
        tipo: "parrafo",
        text: "Without decisions, movement can feel like",
      },
      {
        tipo: "parrafo",
        text: "progress,",
      },
      {
        tipo: "parrafoBloque",
        text: "but leads nowhere.",
      },

      { tipo: "parrafo", text: "Options remain open." },
      { tipo: "parrafo", text: "Energy is scattered" },
      { tipo: "parrafoBloque", text: "Momentum fades." },

      {
        tipo: "parrafo",
        text: "Clarity informs decisions.",
      },
      {
        tipo: "parrafoBloque",
        text: "And decisions create direction.",
      },

      { tipo: "parrafo", text: "Each decision defines what matters," },
      { tipo: "parrafo", text: "and eliminates what doesn’t." },

      { tipo: "cierreBold", text: "Progress doesn’t come from doing more." },
      { tipo: "cierreRegular", text: "It comes from deciding what matters." },
    ],
  },
  {
    id: 4,
    titulo: "Relationships Determine Results.",
    contenido: [
      {
        tipo: "parrafo",
        text: "Decisions are influenced by trust.",
      },
      {
        tipo: "parrafoBloque",
        text: "Direction is shaped through conversation.",
      },

      {
        tipo: "parrafo",
        text: "Without strong relationships, possibilities narrow.",
      },
      {
        tipo: "parrafo",
        text: "Conversations lose depth.",
      },
      {
        tipo: "parrafoBloque",
        text: "Momentum slows.",
      },

      {
        tipo: "parrafo",
        text: "What appears as a lack of opportunity",
      },
      {
        tipo: "parrafo",
        text: "is often a lack of connection –",
      },
      {
        tipo: "parrafoBloque",
        text: "or relationships  that have not been sustained.",
      },

      {
        tipo: "giro",
        text: "Relationships create context.",
      },

      { tipo: "parrafo", text: "They are built over time — " },
      { tipo: "parrafo", text: "through consistency, trust, and presence —" },
      { tipo: "parrafo", text: "and shaped by how we show up —" },
      { tipo: "parrafoBloque", text: "respect, transparency, alignment." },

      {
        tipo: "parrafo",
        text: "They open doors.",
      },
      {
        tipo: "parrafo",
        text: "They accelerate decisions.",
      },
      {
        tipo: "parrafo",
        text: "They shape how we are seen and understood.",
      },

      { tipo: "cierreBold", text: "Results are relational." },
    ],
  },
  {
    id: 5,
    titulo: "SAETA",
    contenido: [
      {
        tipo: "subtitulo",
        text: "A diagnostic lens for clarity and direction.",
      },

      {
        tipo: "parrafo",
        text: "It helps determine",
      },
      {
        tipo: "parrafo",
        text: "where someone is,",
      },
      {
        tipo: "parrafo",
        text: "what the moment requires,",
      },
      {
        tipo: "parrafoBloque",
        text: "and how to move forward.",
      },
      {
        tipo: "parrafo",
        text: "It brings structure without rigidity.",
      },

      {
        tipo: "cierreBold",
        text: "Clarity comes before action.",
      },
    ],
  },
  {
    id: 6,
    titulo: "Networking is not Transactional",
    contenido: [
      {
        tipo: "subtitulo",
        text: "Networking is often approached with urgency — \nor not at all.",
      },

      { tipo: "parrafo", text: "A need." },
      { tipo: "parrafo", text: "A request" },
      { tipo: "parrafoBloque", text: " A goal." },

      {
        tipo: "parrafo",
        text: "It becomes about reaching out,",
      },

      {
        tipo: "parrafo",
        text: "asking for time,",
      },
      {
        tipo: "parrafo",
        text: "or asking for help.",
      },

      { tipo: "giro", text: "This is where people get stuck." },
      {
        tipo: "parrafoBloque",
        text: "Strong relationships are built over time –",
      },
      /*  {
        tipo: "parrafo",
        text: "About asking for favors.",
      },
      {
        tipo: "parrafo",
        text: "About what to say.",
      },

      { tipo: "bold", text: "We believe we are connected." },

      {
        tipo: "parrafo",
        text: "But connection is not measured by access to people.",
      },

      { tipo: "parrafo", text: "It is shaped through relationships." },

      { tipo: "parrafo", text: "Strong relationships are built over time." }, */

      {
        tipo: "parrafo",
        text: "Through consistency.",
      },
      {
        tipo: "parrafo",
        text: "Through presence",
      },
      {
        tipo: "parrafoBloque",
        text: "Through genuine engagement.",
      },

      /*   { tipo: "parrafo", text: "They are not activated only when needed." }, */

      {
        tipo: "parrafo",
        text: "What appears as a lack of opportunity",
      },
      {
        tipo: "parrafoBloque",
        text: "often a lack of connection.",
      },
      /* {
        tipo: "parrafo",
        text: "or relationships that have not been sustained.",
      }, */
      /* 
      {
        tipo: "parrafo",
        text: "Networking is not separate from the process.",
      },
      { tipo: "parrafo", text: "It is what makes it possible." },

      {
        tipo: "cierreBold",
        text: "It is not a transaction.",
      },
      {
        tipo: "cierreRegular",
        text: "It is a relationship over time.",
      }, */
      {
        tipo: "cierreBold",
        text: "Networking is not a transaction.",
      },
      {
        tipo: "cierreRegular",
        text: "It is a relationship over time.",
      },
    ],
  },

  {
    id: 7,
    titulo: "The Pitch",
    contenido: [
      {
        tipo: "subtitulo",
        text: "Most people think of the pitch as something to prepare.",
      },

      {
        tipo: "parrafo",
        text: "A summary",
      },
      {
        tipo: "parrafo",
        text: "A script.",
      },
      {
        tipo: "parrafo",
        text: "A way to introduce themselves.",
      },

      {
        tipo: "giro",
        text: "The pitch is not something you memorize.",
      },

      { tipo: "parrafo", text: "A strong pitch is not about saying more." },

      {
        tipo: "parrafo",
        text: "It is about knowing what you want to be known for,",
      },
      {
        tipo: "parrafo",
        text: "how your experience connects,",
      },
      {
        tipo: "parrafoBloque",
        text: "and what matters now.",
      },

      { tipo: "parrafoBloque", text: "It evolves over time." },

      {
        tipo: "parrafo",
        text: "It changes depending on the context,",
      },
      {
        tipo: "parrafo",
        text: "the audience,",
      },
      {
        tipo: "parrafo",
        text: "the moment,",
      },
      {
        tipo: "parrafoBloque",
        text: "and the question.",
      },

      { tipo: "parrafo", text: "When it is clear, it creates alignment." },
      { tipo: "parrafoBloque", text: "When it is not, it creates confusion." },

      { tipo: "parrafo", text: "The pitch is not a statement." },
      {
        tipo: "cierreBold",
        text: "It is a reflection of clarity — ",
      },
      {
        tipo: "cierreRegular",
        text: "in the present moment.",
      },
    ],
  },

  {
    id: 8,
    titulo: "Interviewing Is a Conversation",
    contenido: [
      {
        tipo: "subtitulo",
        text: "Most people approach interviewing as an evaluation ",
      },
      {
        tipo: "parrafo",
        text: "A test.",
      },
      {
        tipo: "parrafo",
        text: "A performance.",
      },
      {
        tipo: "parrafo",
        text: "A moment to prove themselves.",
      },

      { tipo: "giro", text: "And in part, it is." },

      { tipo: "giro", text: "But it happens within a conversation." },

      {
        tipo: "parrafo",
        text: "In some contexts, the process may include ",
      },
      {
        tipo: "parrafoBloque",
        text: "assessments, tasks, or presentations.",
      },

      {
        tipo: "parrafo",
        text: "These are part of the process.",
      },

      {
        tipo: "parrafo",
        text: "They do not define the interaction.",
      },

      { tipo: "cierreBold", text: "An interview is a conversation." },
      {
        tipo: "cierreRegular",
        text: "The process is a series of conversations.",
      },
    ],
  },


  ];
  
      

   
